import { ApiRequestGet } from "../data/network/services/ApiRequestGet";
import { ApiRequestPost } from "../data/network/services/ApiRequestPost";
import {
  addClientDropdownList,
  addResellerDropdownList,
  addResellerServiceProviderDropdownList,
  addSalesDropdownList,
  addServiceProviderDropdownList,
  addServiceProviderNameDropdownList,
} from "../data/redux/slice/dropDownListSlice";

import { STATUS_CODE_200 } from "../utility/constants/valueConstants";

export const modififyDropdownServiceNameList = (data) => {
  let arr = [];

  data &&
    data?.map((val, i) => {
      let value = "";
      if (val.serviceProviderName?.toUpperCase() === "EQUITAS") {
        value = val.serviceProviderName + `(${val.serviceProviderType})`;
      } else value = val.serviceProviderName;
      arr.push({
        value: val.serviceProviderName,
        label: value,
        rate: val?.serviceProviderRate,
        type: val?.serviceType,
      });
    });

  return arr;
};

export const modififyDropdownServiceProviderNameList = (data) => {
  let arr = [
    {
      label: "None",
      value: "",
    },
  ];
  data &&
    data?.map((val, i) => {
      let value = "";
      if (
        val.serviceProviderName?.toUpperCase() === "EQUITAS" ||
        val.serviceProviderName?.toUpperCase() === "AXIS"
      ) {
        value = val.serviceProviderName + `(${val.serviceProviderType})`;
      } else value = val.serviceProviderName;
      arr.push({
        value: val.serviceProviderName,
        label: value,
        type: val.serviceType,
      });
    });

  return arr;
};

const modifierClientData = (data) => {
  let newArr = [
    {
      label: "None",
      value: "",
    },
  ];

  data &&
    data?.map((val, i) => {
      newArr.push({
        label: val.firstName + " " + val.lastName + " / " + val.businessName,

        value: val?.userId,
      });
    });

  return newArr;
};

const modifierResellerData = (data) => {
  let newArr = [];

  data &&
    data?.map((val, i) => {
      newArr.push({
        label: val.firstName + " " + val.lastName,
        value: val?.userId,
        email: val?.email,
      });
    });

  return newArr;
};

const modififyDropdownServiceTypeList = (data) => {
  let arr = [];
  data &&
    data?.map((val, i) => {
      arr.push({
        value: val?.serviceType,
        label: val.serviceType,
      });
    });

  return arr;
};

export const fetchResellerDropDownList = () => (dispatch) => {
  ApiRequestGet.getResellerList()
    .then((res) => {
      if (res.statusCode === STATUS_CODE_200) {
        dispatch(addResellerDropdownList(modifierClientData(res?.data)));
      }
    })
    .catch((err) => {});
};

export const fetchSalesDropDownList =
  ({ userRefId = "" }) =>
  (dispatch) => {
    ApiRequestGet.getSalesList({
      userRefId,
    })
      .then((res) => {
        if (res.statusCode === STATUS_CODE_200) {
          dispatch(addSalesDropdownList(modifierResellerData(res?.data)));
        }
      })
      .catch((err) => {});
  };

export const fetchClientDropDownList =
  (servicetype = "") =>
  (dispatch) => {
    ApiRequestGet.getClientListWithId({
      isForDropdown: true,
      serviceType: servicetype,
    })
      .then((res) => {
        if (res.statusCode === STATUS_CODE_200) {
          dispatch(addClientDropdownList(modifierClientData(res?.data)));
        }
      })
      .catch((err) => {});
  };

export const fetchServiceProviderDropDownList = () => (dispatch) => {
  ApiRequestGet.getAllServiceProviderList({
    type: "",
  })
    .then((res) => {
      if (res.statusCode === STATUS_CODE_200) {
        dispatch(
          addServiceProviderDropdownList(
            modififyDropdownServiceNameList(res.data)
          )
        );
        dispatch(
          addServiceProviderDropdownList(
            modififyDropdownServiceProviderNameList(res.data)
          )
        );
        dispatch(
          addResellerServiceProviderDropdownList(
            modififyDropdownServiceNameList(res.data)
          )
        );
      }
    })
    .catch((err) => {});
};

export const fetchResellerServiceProviderDropDownList =
  (type) => (dispatch) => {
    ApiRequestGet.fetchResellerServiceProvider({
      servicetype: type,
    })
      .then((res) => {
        if (res.statusCode === STATUS_CODE_200) {
          dispatch(
            addResellerServiceProviderDropdownList(
              modififyDropdownServiceNameList(res.data)
            )
          );
          dispatch(
            addServiceProviderDropdownList(
              modififyDropdownServiceProviderNameList(res.data)
            )
          );
        }
      })
      .catch((err) => {});
  };
